import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { reactReduxFirebase, firebaseReducer } from 'react-redux-firebase';
import createHistory from 'history/createBrowserHistory'
import folioReducer from '../reducers/folio';
import insideReducer from '../reducers/inside';
import { routerMiddleware } from 'react-router-redux'
import { routerReducer } from 'react-router-redux'
import { createLogger } from 'redux-logger';

import thunk from 'redux-thunk'
import firebase from 'firebase'

const initialState = {};
export const history = createHistory();
const logger = createLogger({
  collapsed: (getState, action, logEntry) => !logEntry.error
});

const enhancers = [];

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.devToolsExtension;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
}

const fbConfig = {
  apiKey: 'AIzaSyBJ510FNpoFzfbNl7qFgJNbxJQYhwx3LjQ',
  authDomain: 'chevo-studios.firebaseapp.com',
  databaseURL: 'https://chevo-studios.firebaseio.com',
  storageBucket: "chevo-studios.appspot.com",
  messagingSenderId: "579398805797",
  appId: "1:579398805797:web:763b5267d07d25bf7ed2cc"
};

const rrfConfig = { userProfile: 'users' };
firebase.initializeApp(fbConfig);

const rootReducer = combineReducers({
  firebase: firebaseReducer,
  router: routerReducer,
  folio: folioReducer,
  inside: insideReducer
});

const middleware = [
  thunk,
  routerMiddleware(history),
  logger
];

const store = createStore(
    rootReducer,
    initialState,
    compose(
      reactReduxFirebase(firebase, rrfConfig),
       applyMiddleware(...middleware),
       ...enhancers
    )
);

export default store;



// WEBPACK FOOTER //
// ./src/store/configure-store.js